const promoBlurStockImage: Global.Images = [
    {
        height: 16,
        width: 62,
        urls: [
            {
                url: '/images/feature/promo/stock-blur.png',
                format: 'png',
            },
        ],
    },
    {
        height: 16,
        width: 62,
        urls: [
            {
                url: '/images/feature/promo/stock-blur.png',
                format: 'png',
            },
        ],
    },
];

const promoMobileStockImage: Global.Images = [
    {
        height: 112,
        width: 334,
        urls: [
            {
                url: '/images/feature/promo/stock-mobile@2x.png',
                format: 'png',
            },
        ],
    },
    {
        height: 168,
        width: 501,
        urls: [
            {
                url: '/images/feature/promo/stock-mobile@3x.png',
                format: 'png',
            },
        ],
    },
];

const promoStockImage: Global.Images = [
    {
        height: 80,
        width: 310,
        urls: [
            {
                url: '/images/feature/promo/stock.png',
                format: 'png',
            },
        ],
    },
    {
        height: 160,
        width: 620,
        urls: [
            {
                url: '/images/feature/promo/stock@2x.png',
                format: 'png',
            },
        ],
    },
];

export const PROMO_FEATURE_STOCK_IMAGE_SET: Global.ImageSet = {
    web: {
        blur: promoBlurStockImage,
        small: promoMobileStockImage,
        medium: promoStockImage,
        large: promoStockImage,
    },
    mobile: undefined,
};

const newProductsBlurStockImage: Global.Images = [
    {
        height: 16,
        width: 62,
        urls: [
            {
                url: '/images/feature/new-products/stock-blur.png',
                format: 'png',
            },
        ],
    },
    {
        height: 16,
        width: 62,
        urls: [
            {
                url: '/images/feature/new-products/stock-blur.png',
                format: 'png',
            },
        ],
    },
];

const newProductsMobileStockImage: Global.Images = [
    {
        height: 112,
        width: 334,
        urls: [
            {
                url: '/images/feature/new-products/stock-mobile@2x.png',
                format: 'png',
            },
        ],
    },
    {
        height: 168,
        width: 501,
        urls: [
            {
                url: '/images/feature/new-products/stock-mobile@3x.png',
                format: 'png',
            },
        ],
    },
];

const newProductsStockImage: Global.Images = [
    {
        height: 80,
        width: 310,
        urls: [
            {
                url: '/images/feature/new-products/stock.png',
                format: 'png',
            },
        ],
    },
    {
        height: 160,
        width: 620,
        urls: [
            {
                url: '/images/feature/new-products/stock@2x.png',
                format: 'png',
            },
        ],
    },
];

export const NEW_PRODUCTS_FEATURE_STOCK_IMAGE_SET: Global.ImageSet = {
    web: {
        blur: newProductsBlurStockImage,
        small: newProductsMobileStockImage,
        medium: newProductsStockImage,
        large: newProductsStockImage,
    },
    mobile: undefined,
};

export const getLargeImageUrl = (imageSet: Global.ImageSet): string => {
    const imageUrl = imageSet.web?.large[1].urls[0].url ?? '';

    // get image url from StaticImageData
    if (typeof imageUrl !== 'string' && 'src' in imageUrl) {
        return imageUrl.src;
    }

    return imageUrl;
};
